import type { ReactNode } from 'react';
import { SidebarProvider, SidebarTrigger } from './sidebar';
import { AppSidebar } from './app-siderbar';

interface LayoutProps {
  title: ReactNode;
  children: ReactNode;
  customButton?: ReactNode;
}

export const Layout = ({ children, title, customButton }: LayoutProps) => {
  return (
    <SidebarProvider>
      <AppSidebar />
      <main className="w-full h-full overflow-x-hidden">
        <div className="border-b border-gray-200 bg-white">
          <div className="mx-auto flex w-full max-w-[min(100%,88rem)] items-center gap-4 px-4 py-3 sm:gap-6 sm:px-6 sm:py-3.5">
            <div className="md:hidden">
              <SidebarTrigger />
            </div>

            <div className="flex min-w-0 flex-1 items-center justify-between gap-3">
              <h4 className="flex min-w-0 flex-wrap items-center gap-2 text-lg font-semibold leading-snug sm:gap-3 sm:text-xl">
                {title}
              </h4>
              {customButton}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 sm:py-6">
          <div className="mx-auto w-full max-w-[min(100%,88rem)]">{children}</div>
        </div>
      </main>
    </SidebarProvider>
  );
};
